module.exports = __webpack_public_path__ + "img/tintuc9.bb11c050.png";